import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=32432184&scoped=true&"
import script from "./Highlights.vue?vue&type=script&lang=js&"
export * from "./Highlights.vue?vue&type=script&lang=js&"
import style0 from "./Highlights.vue?vue&type=style&index=0&id=32432184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32432184",
  null
  
)

export default component.exports